import { FieldSettings } from 'shared/types'
import { ConcatFields } from 'shared/utils/object/concatenateFields'
import evaluateFieldDependency from '../../shared/evaluateFieldDependency/evaluateFieldDependency'
import {
  FieldValues,
  FilterField,
  FilterSectionLayout,
  GroupedFieldValues
} from '../../types'
import { InterdependentFilteringConfig } from '../../types/layout'
import Field from '../Field/Field'

type FilterFormProps = {
  sectionLayout?: FilterSectionLayout
  fields: FilterField[]
  fieldValues: FieldValues
  handleChange?: (value: FieldValues) => void
  interdependentFilteringConfig?: InterdependentFilteringConfig
  uuidCurrentSitemodelObjectclass?: string
  groupedFieldValues: GroupedFieldValues
  changedKeysData?: GroupedFieldValues
  fieldSettings?: FieldSettings
  concatFields?: ConcatFields
  groupPosition: number
  selectAndLinkTargetPath?: string
}

const Fields = ({
  sectionLayout,
  fields,
  fieldValues,
  handleChange,
  uuidCurrentSitemodelObjectclass,
  groupedFieldValues,
  interdependentFilteringConfig,
  fieldSettings,
  groupPosition,
  concatFields,
  selectAndLinkTargetPath,
  changedKeysData
}: FilterFormProps) => {
  return (
    <div className='container-fluid px-0'>
      <div className='row align-items-end'>
        {fields.map((field) => {
          if (!field.uuid) return null

          const {
            disabled,
            interdependentFilteringQuery,
            dependant,
            dependantFieldName
          } = evaluateFieldDependency({
            fieldName: field.name || '',
            fieldValues,
            interdependentFilteringConfig
          })

          const handleChangeAndClearDependant: typeof handleChange = (
            value
          ) => {
            if (!handleChange) {
              return
            }

            if (!dependantFieldName || !dependant?.value.length) {
              handleChange(value)
              return
            }

            handleChange({
              ...value,
              [dependantFieldName]: {
                ...dependant,
                value: Array.isArray(dependant.value) ? [] : ''
              }
            })
          }

          const dateFormat =
            fieldSettings?.[field?.name as string]?.date_format || 'date-time'

          const fieldConcatenation = concatFields?.[field?.name as string]

          const changedFilteractionData = field?.name
            ? changedKeysData?.[groupPosition]?.[field?.name]
            : undefined
          const enableQRCodeReader =
            fieldSettings?.[field?.name as string]?.enable_qr_code_reader

          return (
            <Field
              key={field.uuid}
              props={field}
              fieldLayout={sectionLayout?.filter_fields.find(
                (fieldLayout) => fieldLayout.field_uuid === field.uuid
              )}
              handleChange={handleChangeAndClearDependant}
              {...{
                fieldValues,
                changedFilteractionData,
                uuidCurrentSitemodelObjectclass,
                groupedFieldValues,
                interdependentFilteringQuery,
                disabled,
                dateFormat,
                groupPosition,
                fieldConcatenation,
                selectAndLinkTargetPath,
                enableQRCodeReader
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Fields
